import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Input } from 'antd';

const EditCategoryModal = ({
  visible,
  onCancel,
  onOk,
  categoryName,
  categorySlug,
  categoryDescription,
  onNameChange,
  onDescriptionChange,
  nameStatus,
  nameHelp
}) => {
  return (
    <Modal
      title="Edit Category"
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Save"
      cancelText="Cancel"
    >
      <Form layout="vertical">
        <Form.Item 
          label="Category Name"
          validateStatus={nameStatus}
          help={nameHelp}
          required
          tooltip="Enter a descriptive name for your category (minimum 3 characters)"
        >
          <Input
            value={categoryName}
            onChange={onNameChange}
            placeholder="Enter new category name"
            status={nameStatus}
          />
        </Form.Item>
        <Form.Item 
          label="Slug"
          required
          tooltip="This is used in the URL and cannot be changed"
        >
          <Input value={categorySlug} disabled />
        </Form.Item>
        <Form.Item 
          label="Description"
          tooltip="Provide a clear description of what this category represents"
        >
          <Input.TextArea
            rows={4}
            value={categoryDescription}
            onChange={onDescriptionChange}
            placeholder="Enter description"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

EditCategoryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  categoryDescription: PropTypes.string.isRequired,
  onNameChange: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  nameStatus: PropTypes.string,
  nameHelp: PropTypes.string
};

export default EditCategoryModal; 